import React from 'react';
import './LongTermScheduleCalendar.scss';
import cls from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBell,
    faCancel,
    faMoon,
    faPencil,
    faThumbsUp,
} from '@fortawesome/free-solid-svg-icons';
import { faNoteSticky } from '@fortawesome/free-regular-svg-icons';

export function getStatusChar(event) {
    if (event.isCancelled) {
        return <FontAwesomeIcon icon={faCancel} />;
    }

    if (event.isReleased) {
        return <FontAwesomeIcon icon={faThumbsUp} />;
    }

    if (event.isPublished) {
        return <FontAwesomeIcon icon={faBell} />;
    }

    if (event.isAssigned) {
        return <FontAwesomeIcon icon={faPencil} />;
    }

    return <FontAwesomeIcon icon={faNoteSticky} />;
}

export default class LtsJobCard extends React.Component {
    render() {
        const { event, handleEventSelect } = this.props;

        if (!event) {
            return null;
        }

        const crewColorSet = Boolean(event.isPublished && event.crewColorHex);

        const borderColor = event.divisionColorHex || '#999';
        const bgColor = crewColorSet ? event.crewColorHex : '#fff';

        const title = event.contractNumber
            ? `${event.contractNumber} - ${event.crewName}`
            : null;

        const eventStartForKey = event.start
            ? event.start.toISOString()
            : 'undefined';

        return (
            <div
                key={`${event.id}-${eventStartForKey}`}
                className={cls('lts-job-card', {
                    'no-click': !event.showKeyIcon,
                })}
                style={{ borderColor, backgroundColor: bgColor }}
                onClick={() => handleEventSelect(event)}
                title={title}
            >
                {event.text && (
                    <span className={cls({ 'invert-text': crewColorSet })}>
                        {event.text}
                    </span>
                )}

                {!event.text && (
                    <>
                        <span
                            className={cls('lts-job-num', {
                                'invert-text': crewColorSet,
                            })}
                        >
                            {event.contractNumber}
                        </span>
                        <span
                            className={cls('lts-job-sep', {
                                'invert-text': crewColorSet,
                            })}
                        >
                            -
                        </span>
                        <span
                            className={cls('lts-job-crew', {
                                'invert-text': crewColorSet,
                            })}
                        >
                            {event.crewName}
                        </span>
                        {event.isNightShift && (
                            <span
                                className={cls('lts-night-icon', {
                                    'invert-color': crewColorSet,
                                })}
                            >
                                <FontAwesomeIcon icon={faMoon} />
                            </span>
                        )}
                        {event.showKeyIcon && (
                            <span
                                className={cls('lts-status-icon', 'ml-auto', {
                                    'invert-color': crewColorSet,
                                })}
                            >
                                {getStatusChar(event)}
                            </span>
                        )}
                    </>
                )}
            </div>
        );
    }
}
